const Footer = () => {
	return (
		<footer className="bg-light py-5">
			<div className="container px-4 px-lg-5"><div className="small text-center text-muted">Copyright &copy; 2022 - Công ty Cổ phần Tập Đoàn Hoàng Minh Trung</div></div>
		</footer>
	)
}
export default Footer;